import React, { useEffect, useRef, useState } from "react";
import Close from './../assets/images/close_icon.svg'
import InputFields from "../components/InputFields";

import useOutsideClick from "../hooks/useOutsideClick";
import { useAddOrderDetails, useGetAllMenu, useUpdateOrderDetails } from "../hooks/hooks";
import deleteicon from './../assets/images/delete.svg';
import { showSuccessToast } from './../components/common';
import moment from "moment";


const OrderDetails = ({ isOpen, onClose, selectedOrder }) => {
    const { data: menuLists } = useGetAllMenu();

    const [inputValue, setInputValue] = useState({ orderId: '', mPrice: '', mTotalPerson: '', mTotal: 0, aPrice: '', aTotalPerson: '', aTotal: 0, nPrice: '', nTotalPerson: '', nTotal: 0, totalAmount: 0, paidByClient: 0, dueamount: 0 });
    const [Error, setError] = useState({ partyName: "", farmName: "", farmAddress: "", eventDate: '' });

    const [startDate, setStartDate] = useState(new Date());

    const [isPopoverOpen, setPopoverOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [orderDetailsId, setOrderDetailsId] = useState(null);
    const [morningOptions, setMorningOptions] = useState([]);

    const [isAfternoonPopoverOpen, setAfternoonPopoverOpen] = useState(false);
    const [afternoonselectedOptions, setAfternoonSelectedOptions] = useState([]);

    const [isNightPopoverOpen, setNightPopoverOpen] = useState(false);
    const [nightSelectedOptions, setNightSelectedOptions] = useState([]);

    const menuOptionsRef = useRef(null);
    useOutsideClick(menuOptionsRef, () => setPopoverOpen(false));

    const afternoonRef = useRef(null);
    useOutsideClick(afternoonRef, () => setAfternoonPopoverOpen(false));

    const nightRef = useRef(null);
    useOutsideClick(nightRef, () => setNightPopoverOpen(false));

    const { mutate: addOrderDetail, isLoading } = useAddOrderDetails();
    const { mutate: updateOrderDetail } = useUpdateOrderDetails();

    
    const [isOpenConfirm, setIsOpenConfirm] = useState(false);



    useEffect(() => {
        if (selectedOrder) {
            const orderDetails = selectedOrder.OrderDetails;

            if (orderDetails && orderDetails.length > 0) {
                const orderDetail = orderDetails[0];
                setIsEdit(true);
                setOrderDetailsId(orderDetail._id);

                setInputValue({
                    mPrice: orderDetail.mPrice || '',
                    mTotalPerson: orderDetail.mTotalPerson || '',
                    mTotal: orderDetail.mTotal || 0,
                    aPrice: orderDetail.aPrice || '',
                    aTotalPerson: orderDetail.aTotalPerson || '',
                    aTotal: orderDetail.aTotal || 0,
                    nPrice: orderDetail.nPrice || '',
                    nTotalPerson: orderDetail.nTotalPerson || '',
                    nTotal: orderDetail.nTotal || 0,
                    totalAmount: orderDetail.totalAmount || 0,
                    paidByClient: orderDetail.paidByClient || 0,
                    dueamount: orderDetail.dueAmount || 0,
                });


                setMorningOptions(orderDetail.morningMenu);
                setAfternoonSelectedOptions(orderDetail.afternoonMenu);
                setNightSelectedOptions(orderDetail.nightMenu);
            }
        }
    }, [selectedOrder]);

    const togglePopover = () => {
        setPopoverOpen(!isPopoverOpen);
    };

    const togglePopoverAfternoon = () => {
        setAfternoonPopoverOpen(!isAfternoonPopoverOpen);
    };

    const togglePopoverNight = () => {
        setNightPopoverOpen(!isNightPopoverOpen);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue({
            ...inputValue,
            [name]: value.toString(),
        });
        setError({ ...Error, partyName: "", farmName: true });
    };

    const onSubmit = () => {
        const orderDetailData = {
            ...inputValue,
            orderId: selectedOrder._id,
            morningOptions: morningOptions,
            afternoonselectedOptions: afternoonselectedOptions,
            nightSelectedOptions: nightSelectedOptions
        };


        if (isEdit) {
            orderDetailData._id = orderDetailsId;
            updateOrderDetail(orderDetailData, {
                onSuccess: (res) => {
                    showSuccessToast(res?.data?.message);
                    onClose(true);
                    setError({ ...Error, name: '' });
                },
                onError: (err) => {
                    setError({ ...Error, all: err.response.data.error });
                },
            });
        } else {
            addOrderDetail(orderDetailData, {
                onSuccess: (res) => {
                    showSuccessToast(res?.data?.message);
                    onClose(true);
                    setError({ ...Error, name: '' });
                },
                onError: (err) => {
                    setError({ ...Error, all: err.response.data.error });
                },
            });
        }
    }

    const calcMorning = () => {
        if (inputValue.mPrice && inputValue.mTotalPerson) {
            setInputValue((prevState) => {
                const updatedState = {
                    ...prevState,
                    mTotal: prevState.mPrice * prevState.mTotalPerson,
                };
                calcGrandTotal(updatedState);
                return updatedState;
            });
        }
    };

    const calcAfternoon = () => {
        if (inputValue.aPrice && inputValue.aTotalPerson) {
            setInputValue((prevState) => {
                const updatedState = {
                    ...prevState,
                    aTotal: prevState.aPrice * prevState.aTotalPerson,
                };
                calcGrandTotal(updatedState);
                return updatedState;
            });
        }
    };

    const calcNight = () => {
        if (inputValue.nPrice && inputValue.nTotalPerson) {
            setInputValue((prevState) => {
                const updatedState = {
                    ...prevState,
                    nTotal: prevState.nPrice * prevState.nTotalPerson,
                };
                calcGrandTotal(updatedState);
                return updatedState;
            });
        }
    };

    const calcGrandTotal = (updatedState) => {
        const { mTotal, aTotal, nTotal } = updatedState;

        const totalAmount =
            (mTotal || 0) +
            (aTotal || 0) +
            (nTotal || 0);

        setInputValue((prevState) => ({
            ...prevState,
            totalAmount: totalAmount,
        }));

        if (inputValue.paidByClient) {
            setInputValue((prevState) => ({
                ...prevState,
                dueamount: totalAmount - inputValue.paidByClient
            }));
        } else {
            setInputValue((prevState) => ({
                ...prevState,
                dueamount: totalAmount
            }));
        }
    };

    const calcDueamount = (value) => {
        if (inputValue.totalAmount) {
            const val = value || 0;
            setInputValue((prevState) => ({
                ...prevState,
                dueamount: inputValue.totalAmount - val
            }));
        }
    }

    const handleCheckboxChange = (option) => {
        setMorningOptions((prevState) => {
            if (prevState.includes(option.menuName)) {
                return prevState.filter((item) => item !== option.menuName);
            } else {
                return [...prevState, option.menuName];
            }
        });
    };

    const removeMenuItem = (itemToRemove) => {
        setMorningOptions((prev) => prev.filter(item => item !== itemToRemove));
    };

    const handleCheckboxChangeForAfternoon = (option) => {
        setAfternoonSelectedOptions((prevState) => {
            if (prevState.includes(option.menuName)) {
                return prevState.filter((item) => item !== option.menuName);
            } else {
                return [...prevState, option.menuName];
            }
        });
    };

    const removeMenuItemForAfternoon = (itemToRemove) => {
        setAfternoonSelectedOptions((prev) => prev.filter(item => item !== itemToRemove));
    };

    const handleCheckboxChangeForNight = (option) => {
        setNightSelectedOptions((prevState) => {
            if (prevState.includes(option.menuName)) {
                return prevState.filter((item) => item !== option.menuName);
            } else {
                return [...prevState, option.menuName];
            }
        });
    };

    const removeMenuItemForNight = (itemToRemove) => {
        setNightSelectedOptions((prev) => prev.filter(item => item !== itemToRemove));
    };

    return (
        <>
            {isOpen && (
                <div className="popup-overlay ">
                    <div className="popup-content w-3/4">
                        <div className="flex justify-center items-center text-[16px] font-semibold text-secondary relative">
                            Order Details
                            <div
                                className="right-[0px] absolute cursor-pointer hover:bg-[#08665624] hover:rounded-[20px] w-[30px] h-[30px] flex items-center justify-center"
                                onClick={() => {
                                    setIsOpenConfirm(true);

                                    // onClose(false);
                                    // setError({ partyName: "", farmName: "" });
                                }}
                            >
                                <img src={Close} alt="" />
                            </div>
                        </div>

                        <hr className="h-[1px] mt-[14px] bg-[#EAEAFF]"></hr>

                        <div className="p-[10px]">

                            <div className="grid grid-cols-2 gap-4">
                                <div className="flex">
                                    <span className="min-w-[125px] font-semibold">Party Name</span>
                                    <span> : {selectedOrder?.partyName || 'N/A'}</span>
                                </div>
                                <div className="flex ">
                                    <span className="min-w-[125px] font-semibold">Farm Name</span>
                                    <span> : {selectedOrder?.farmName || 'N/A'}</span>
                                </div>
                                <div className="flex w-full overflow-clip">
                                    <div className="min-w-[125px] font-semibold">Farm Address</div>
                                    <div className="break-words"> : {selectedOrder?.farmAddress || 'N/A'}</div>
                                </div>
                                <div className="flex">
                                    <span className="min-w-[125px] font-semibold">Event Date</span>
                                    <span> : {selectedOrder?.eventDate ? moment(selectedOrder?.eventDate).format('DD-MM-YYYY') : 'N/A'}</span>
                                </div>
                            </div>
                            <hr className="h-[1px] mt-[14px] bg-[#EAEAFF]"></hr>

                            <div className="grid grid-cols-3 gap-8 mt-5">

                                <div className="relative">
                                    <div className="flex justify-center font-semibold">Morning</div>
                                    <div ref={menuOptionsRef} onClick={(e) => { e.stopPropagation(); }}>
                                        <div className="h-[35px] border rounded px-2 flex items-center mt-1 cursor-pointer text-[14px]"
                                            onClick={() => {
                                                togglePopover();
                                                setNightPopoverOpen(false);
                                                setAfternoonPopoverOpen(false);
                                            }}>
                                            Select Menu
                                        </div>
                                        {isPopoverOpen && (
                                            <div className="absolute w-full top-[60px] left-[50%] transform -translate-x-[50%] bg-white border rounded p-2 shadow-lg
                                            max-h-[185px] overflow-auto" style={{ zIndex: '99' }}>
                                                <div className="flex flex-col">
                                                    {menuLists.map((option, index) => (
                                                        <div key={index} className="flex items-center p-2 cursor-pointer"
                                                            onClick={() => handleCheckboxChange(option)}>
                                                            <input
                                                                type="checkbox"
                                                                checked={morningOptions.includes(option.menuName)}
                                                                className="mr-2"
                                                            />
                                                            <span className="text-[12px]">{option.menuName}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="border rounded h-[150px] mt-1 overflow-auto">
                                        <div className="flex flex-col space-y-1">
                                            {morningOptions.map((menuItem, index) => (
                                                <div key={index} className="flex justify-between items-center border-b py-1 px-3 text-[14px]">
                                                    <span>{index + 1}. {menuItem}</span>
                                                    <button
                                                        className="text-red-500 font-semibold"
                                                        onClick={() => removeMenuItem(menuItem)}
                                                    >
                                                        <img alt="" width={12} className="cursor-pointer" src={deleteicon} />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>


                                    <div className="grid grid-cols-2 items-center">
                                        <label>Price</label>
                                        <InputFields
                                            name="mPrice"
                                            label="Price"
                                            type="text"
                                            placeholder="Price"
                                            isHideLabel="true"
                                            isFixedLabel="true"
                                            disabled={isLoading}
                                            handleChange={(e) => {
                                                handleChange(e);
                                                calcMorning();
                                            }}
                                            value={inputValue?.mPrice}
                                            className="text-input mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]"
                                        >
                                        </InputFields>


                                    </div>

                                    <div className="grid grid-cols-2 items-center">
                                        <label>Total Person</label>
                                        <InputFields
                                            name="mTotalPerson"
                                            label="mTotalPerson"
                                            type="text"
                                            placeholder="Total Person"
                                            isHideLabel="true"
                                            isFixedLabel="true"
                                            disabled={isLoading}
                                            handleChange={(e) => {
                                                handleChange(e);
                                                calcMorning();
                                            }}
                                            value={inputValue?.mTotalPerson}
                                            className="text-input mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]"
                                        >
                                        </InputFields>


                                    </div>
                                    <div className="grid grid-cols-2 items-center">
                                        <label>Total</label>
                                        <label className="text-input items-center flex mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]">
                                            {inputValue.mTotal}
                                        </label>
                                    </div>


                                </div>

                                <div className="relative">
                                    <div className="flex justify-center font-semibold">Afternoon</div>
                                    <div ref={afternoonRef} onClick={(e) => { e.stopPropagation(); }}>
                                        <div className="h-[35px] border rounded px-2 flex items-center mt-1 cursor-pointer text-[14px]"
                                            onClick={() => {
                                                setPopoverOpen(false);
                                                setNightPopoverOpen(false);
                                                togglePopoverAfternoon();

                                            }}>
                                            Select Menu
                                        </div>
                                        {isAfternoonPopoverOpen && (
                                            <div className="absolute w-full top-[60px] left-[50%] transform -translate-x-[50%] bg-white border rounded p-2 shadow-lg
                                            max-h-[185px] overflow-auto" style={{ zIndex: '99' }}>
                                                <div className="flex flex-col">
                                                    {menuLists.map((option, index) => (
                                                        <div key={index} className="flex items-center p-2 cursor-pointer"
                                                            onClick={() => handleCheckboxChangeForAfternoon(option)}>
                                                            <input
                                                                type="checkbox"
                                                                checked={afternoonselectedOptions.includes(option.menuName)}
                                                                className="mr-2"
                                                            />
                                                            <span className="text-[12px]">{option.menuName}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="border rounded h-[150px] mt-1 overflow-auto">
                                        <div className="flex flex-col space-y-1">
                                            {afternoonselectedOptions.map((menuItem, index) => (
                                                <div key={index} className="flex justify-between items-center border-b py-1 px-3 text-[14px]">
                                                    <span>{index + 1}. {menuItem}</span>
                                                    <button
                                                        className="text-red-500 font-semibold"
                                                        onClick={() => removeMenuItemForAfternoon(menuItem)}
                                                    >
                                                        <img alt="" width={12} className="cursor-pointer" src={deleteicon} />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>


                                    <div className="grid grid-cols-2 items-center">
                                        <label>Price</label>
                                        <InputFields
                                            name="aPrice"
                                            label="aPrice"
                                            type="text"
                                            placeholder="Price"
                                            isHideLabel="true"
                                            isFixedLabel="false"
                                            disabled={isLoading}
                                            handleChange={(e) => {
                                                handleChange(e);
                                                calcAfternoon();
                                            }}
                                            value={inputValue?.aPrice}
                                            className="text-input mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]"
                                        >
                                        </InputFields>
                                    </div>

                                    <div className="grid grid-cols-2 items-center">
                                        <label>Total Person</label>
                                        <InputFields
                                            name="aTotalPerson"
                                            label="aTotalPerson"
                                            type="text"
                                            placeholder="Total Person"
                                            isHideLabel="true"
                                            isFixedLabel="true"
                                            disabled={isLoading}
                                            handleChange={(e) => {
                                                handleChange(e);
                                                calcAfternoon();
                                            }}
                                            value={inputValue?.aTotalPerson}
                                            className="text-input mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]"
                                        >
                                        </InputFields>
                                    </div>
                                    <div className="grid grid-cols-2 items-center">
                                        <label>Total</label>
                                        <label className="text-input items-center flex mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]">
                                            {inputValue.aTotal}
                                        </label>
                                    </div>
                                </div>

                                <div className="relative">
                                    <div className="flex justify-center font-semibold">Night</div>
                                    <div ref={nightRef} onClick={(e) => { e.stopPropagation(); }}>
                                        <div className="h-[35px] border rounded px-2 flex items-center mt-1 cursor-pointer text-[14px]"
                                            onClick={() => {
                                                setPopoverOpen(false);
                                                setNightPopoverOpen(false);
                                                togglePopoverNight();
                                            }}>
                                            Select Menu
                                        </div>
                                        {isNightPopoverOpen && (
                                            <div className="absolute w-full top-[60px] left-[50%] transform -translate-x-[50%] bg-white border rounded p-2 shadow-lg
                                            max-h-[185px] overflow-auto" style={{ zIndex: '99' }}>
                                                <div className="flex flex-col">
                                                    {menuLists.map((option, index) => (
                                                        <div key={index} className="flex items-center p-2 cursor-pointer"
                                                            onClick={() => handleCheckboxChangeForNight(option)}>
                                                            <input
                                                                type="checkbox"
                                                                checked={nightSelectedOptions.includes(option.menuName)}
                                                                className="mr-2"
                                                            />
                                                            <span className="text-[12px]">{option.menuName}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="border rounded h-[150px] mt-1 overflow-auto">
                                        <div className="flex flex-col space-y-1">
                                            {nightSelectedOptions.map((menuItem, index) => (
                                                <div key={index} className="flex justify-between items-center border-b py-1 px-3 text-[14px]">
                                                    <span>{index + 1}. {menuItem}</span>
                                                    <button
                                                        className="text-red-500 font-semibold"
                                                        onClick={() => removeMenuItemForNight(menuItem)}
                                                    >
                                                        <img alt="" width={12} className="cursor-pointer" src={deleteicon} />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-2 items-center">
                                        <label>Price</label>
                                        <InputFields
                                            name="nPrice"
                                            label="nPrice"
                                            type="text"
                                            placeholder="Price"
                                            isHideLabel="true"
                                            isFixedLabel="true"
                                            disabled={isLoading}
                                            handleChange={(e) => {
                                                handleChange(e);
                                                calcNight();
                                            }}
                                            value={inputValue?.nPrice}
                                            className="text-input mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]"
                                        >
                                        </InputFields>


                                    </div>

                                    <div className="grid grid-cols-2 items-center">
                                        <label>Total Person</label>
                                        <InputFields
                                            name="nTotalPerson"
                                            label="nTotalPerson"
                                            type="text"
                                            placeholder="Total Person"
                                            isHideLabel="true"
                                            isFixedLabel="true"
                                            disabled={isLoading}
                                            handleChange={(e) => {
                                                handleChange(e);
                                                calcNight();
                                            }}
                                            value={inputValue?.nTotalPerson}
                                            className="text-input mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]"
                                        >
                                        </InputFields>


                                    </div>
                                    <div className="grid grid-cols-2 items-center">
                                        <label>Total</label>
                                        <label className="text-input items-center flex mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]">
                                            {inputValue.nTotal}
                                        </label>
                                    </div>
                                </div>

                            </div>

                            <hr className="h-[1px] mt-[14px] bg-[#EAEAFF]"></hr>
                            <div className="grid grid-cols-3 gap-8 mt-5">
                                <div className="grid grid-cols-2 items-center">
                                    <label>Total Due Amount</label>
                                    <label className="text-input items-center flex mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]">
                                        {inputValue.totalAmount}
                                    </label>
                                </div>
                                <div className="grid grid-cols-2 items-center">
                                    <label>Paid by client</label>
                                    <InputFields
                                        name="paidByClient"
                                        label="paidByClient"
                                        type="text"
                                        placeholder="Paid by Client"
                                        isHideLabel="true"
                                        isFixedLabel="true"
                                        disabled={isLoading}
                                        handleChange={(e) => {
                                            handleChange(e);
                                            setTimeout(calcDueamount(e.target.value), 100);
                                        }}
                                        value={inputValue?.paidByClient}
                                        className="text-input mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]"
                                    >
                                    </InputFields>
                                </div>
                                <div className="grid grid-cols-2 items-center">
                                    <label>Due Amount</label>
                                    <label className="text-input items-center flex mt-[5px] w-full h-[30px] px-[19px] text-[14px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]">
                                        {inputValue.dueamount}
                                    </label>
                                </div>
                            </div>
                            <hr className="h-[1px] mt-[14px] bg-[#EAEAFF]"></hr>
                            <div className="flex justify-end  mt-[14px] gap-3 ">
                                <button className="border rounded px-3 h-10 text-red-500 font-semibold"
                                    onClick={() => {
                                        setIsOpenConfirm(true);
                                        // onClose(false);
                                        // setError({ partyName: "", farmName: "" });
                                    }}
                                >Cancel</button>
                                <button className="border rounded px-3 h-10 text-green-500  font-semibold"
                                    onClick={onSubmit}
                                >SAVE</button>
                            </div>
                        </div>

                    </div>

                </div>
            )}

            {isOpenConfirm && (
                <div className="popup-overlay ">
                    <div className="popup-content !w-[300px] !p-[22px]" onClick={(e) => e.stopPropagation()}>
                        <div className='text-[15px] pt-[13px] font-medium text-[#000] w-full flex justify-center items-center flex-col'>
                            <span>Are you sure</span>
                            <span>you want to close?</span>
                        </div>

                        <div className='flex items-center mt-[35px] gap-[9px]'>
                            <div className='w-[50%]'>
                                <button className='w-full h-[52px] rounded-[26px] bg-[#E5E5E5] text-[15px] font-[600] text-[#36367A]'
                                    onClick={() => { setIsOpenConfirm(false); }}>
                                    NO
                                </button>
                            </div>
                            <div className='w-[50%]'>
                                <button className='w-full h-[52px] rounded-[26px] bg-secondary text-[15px] font-[600] text-white'
                                    onClick={() => { setIsOpenConfirm(false);onClose(true); }}>
                                    YES
                                </button>
                            </div>
                        </div>

                    </div>
                </div>)}
        </>
    )
}

export default OrderDetails;
